import React from 'react';
import { Link } from 'react-router-dom'

class ErrorBoundary extends React.Component {
    constructor(props) {
        super(props);
        this.state = { hasError: false };
    }

    componentDidCatch(error, info) {
        // Display fallback UI
        this.setState({ hasError: true });
        // You can also log the error to an error reporting service
        console.error("Uncaught exception", error, info);
    }

    render() {
        if (this.state.hasError) {
            // You can render any custom fallback UI
            return <>
                <h4>Something went wrong.</h4>
                <br></br>
                <Link to="/login">Login again</Link>
            </>;
        }
        return this.props.children;
    }
}

export default ErrorBoundary;